import { render, staticRenderFns } from "./Amortization.vue?vue&type=template&id=20e747c4&scoped=true"
import script from "./Amortization.vue?vue&type=script&lang=js"
export * from "./Amortization.vue?vue&type=script&lang=js"
import style0 from "./Amortization.vue?vue&type=style&index=0&id=20e747c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e747c4",
  null
  
)

export default component.exports